import { CollapsedCommunityTrigger } from "./CollapsedCommunityTrigger";
import { useCommunityHeader } from "./useCommunityHeaderRows";

export const CircleAIDockCommunityHeaderCollapsed = () => {
  const { canGoBack, communityName, currentAvatar, goBackToCommunity, rows } =
    useCommunityHeader();

  return (
    <div className="flex justify-center px-2 pt-4">
      <CollapsedCommunityTrigger
        communityName={communityName}
        rows={rows}
        canGoBack={canGoBack}
        onGoBack={goBackToCommunity}
      >
        {currentAvatar}
      </CollapsedCommunityTrigger>
    </div>
  );
};
